import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LabelType, ProducedMaterial, ProducedMaterialService } from 'chronos-core-client';
import { ActiveWorkCenterService } from '@app/core/workcenter';

@Injectable({
  providedIn: 'root'
})
export class ProducedMaterialDsService {
  constructor(private producedMaterialService: ProducedMaterialService, private activeWorkCenterService: ActiveWorkCenterService) {}

  public setProducedForwardedWaste(producedMaterial: ProducedMaterial): Observable<void> {
    // Forwarded waste must be either true or false, so if it's null, we don't need to make a request. This happens when the produced material is finished.
    if (producedMaterial.containsForwardedWaste == null) {
      return of(null);
    }
    return this.producedMaterialService.setForwardedWaste({
      producedMaterialId: producedMaterial.producedMaterialId,
      body: {
        containsForwardedWaste: producedMaterial.containsForwardedWaste,
        workCenterId: producedMaterial.producedWorkCenterId
      }
    });
  }

  public changeProducedMaterialPrintInfo(
    producedMaterialId: number,
    labelType: LabelType,
    quantityPerOuter: number,
    numberOfCopies: number
  ): Observable<void> {
    return this.producedMaterialService.changeProducedMaterialPrintInfo({
      producedMaterialId,
      body: {
        numberCopies: numberOfCopies,
        labelType,
        quantityPerOuter,
        workCenterId: this.activeWorkCenterService.getWorkCenterId()
      }
    });
  }
}
